module.exports = __webpack_public_path__ + "static/media/contactsContent.1bf348e0.png";